// SAD-859: the out-of-scope package for a mod or REA. One ZIP holding
// out-of-scope.csv (one row per work product, with who asked and its
// evidence) and every evidence file under evidence/. A link stays a link in
// the CSV. A file that cannot be fetched is named in the CSV as missing,
// never silently dropped.
import JSZip from 'jszip';
import { safeName, workProductsCsv } from './workProducts';
export async function buildOutOfScopeZip(rows, deps) {
    const zip = new JSZip();
    const refs = new Map();
    const missing = [];
    let n = 0;
    for (const wp of rows){
        const out = [];
        for (const a of wp.attachments){
            if (a.url) {
                out.push(a.url);
                continue;
            }
            const name = deps.artifactName(a.artifactId) || a.label || 'file';
            n += 1;
            const path = `evidence/${String(n).padStart(3, '0')}-${safeName(name)}`;
            try {
                zip.file(path, await deps.fetchArtifact(a.artifactId));
                out.push(path);
            } catch  {
                missing.push(name);
                out.push(`MISSING: ${name} (download it from the app)`);
            }
        }
        refs.set(wp.id, out);
    }
    const csv = workProductsCsv(rows, deps.teamName, (wp)=>(refs.get(wp.id) ?? []).map((reference)=>({
                reference
            })), deps.personName);
    zip.file('out-of-scope.csv', csv);
    const blob = await zip.generateAsync({
        type: 'blob'
    });
    return {
        zip: blob,
        csv,
        files: n - missing.length,
        missing
    };
}
